import { EventEmitter, HostListener, Output } from '@angular/core';
import { Component, OnInit, Input, forwardRef, ViewChild, Optional, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { ElementBase } from '../../base/element-base';
import { DropDownItem } from '../dropdown.item';

@Component({
  selector: 'app-dropdown-list',
  templateUrl: './dropdown-list.component.html',
  styleUrls: ['./dropdown-list.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownListComponent),
      multi: true
    }
  ]
})
export class DropdownListComponent extends ElementBase<any> {

  private _showMenu = false;
  private _isClickInside = false;

  @Input()
  items: DropDownItem[];

  @Input()
  shortText = false;

  @Output() ngModelChange = new EventEmitter();

  @ViewChild(NgModel, { static: true }) model: NgModel;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
  ) {
    super(validators, asyncValidators);
  }

  ngOnInit() {
    if (!this.items) {
      return;
    }
    if (this.items.length === 1) {
      this.ngModelChange.emit(this.items[0].value);
    }
  }

  onClickMenu(): void {
    if (this._showMenu) {
      this._showMenu = false;
    } else {
      this._showMenu = true;
    }
  }

  get showDropDownMenu(): boolean {
    return this._showMenu;
  }

  onSelectValue(value: any): void {
    this.value = value;
    this.onClickMenu();
  }

  get selectedDropDownName(): string {
    if (!this.items || this.items.length === 0) {
      return '';
    }
    const findItem = this.items.find(item => item.value === this.value);
    return findItem && findItem.name ? findItem.name : '';
  }

  @HostListener('document:click')
  clickOut(): void {
    if (!this._isClickInside) {
      this._showMenu = false;
    }
    this._isClickInside = false;
  }

  @HostListener('click')
  clickInside(): void {
    this._isClickInside = true;
  }


  get canSelect(): boolean {
    return this.items?.length > 1;
  }
}
